import { api, streamCountrySheet } from "../../api/client";
import type { CountrySection, CountrySheet } from "../../api/types";
import { createDocumentJob, type DocumentJob } from "../briefing/documentJob";

/** Rédaction de la fiche pays en cours (même magasin que la mise en ambiance) : la fiche composée par Generex
 *  arrive d'abord entière (`sheet`), puis chaque rubrique de texte s'écrit sous les yeux. */

export type CountryJob = DocumentJob<CountrySection>;

export const countrySheetKey = (exerciseId: string | null) => ["country-sheet", exerciseId] as const;

/** `reuse` : paragraphes inchangés depuis leur dernière rédaction repris tels quels (« À régénérer », « Rédiger la
 *  fiche pays ») ; absent : tout est rédigé de nouveau (« Régénérer »). */
export type CountryJobBody = { sections?: string[] | null; keep_edits?: boolean; resume?: boolean; reseed?: boolean; reuse?: boolean };

export const useCountryJob = createDocumentJob<CountrySheet, CountrySection, CountryJobBody>({
  queryKey: countrySheetKey,
  stream: (exerciseId, body, onEvent, signal) => streamCountrySheet(exerciseId, body, onEvent, signal),
  stopRemote: (exerciseId) => api.stopCountrySheet(exerciseId),
  // Fiche composée dès la lecture du dossier, puis complète à la fin de la rédaction.
  document: (event, data) =>
    event === "sheet" ? (data as unknown as CountrySheet) : event === "done" ? (data.sheet as CountrySheet | null) : undefined,
});
